export interface GuideStep {
  id: number
  title: string
  href: string
  disabled?: boolean
  locked?: boolean
  sections?: Array<{
    id?: string
    title: string
  }>
}

const GUIDE_STEP_TITLE_MAP = {
  zh: {
    introduction: "服务介绍",
    account: "立即开户",
    warehouseInfo: "获得海外仓地址",
    prepare: "准备你的商品",
    shipping: "发货至海外仓",
    integration: "拉取平台订单",
    operations: "处理日常业务",
    support: "处理异常情况",
  },
  en: {
    introduction: "Service overview",
    account: "Open account",
    warehouseInfo: "Get warehouse address",
    prepare: "Prepare your products",
    shipping: "Ship to warehouse",
    integration: "Import platform orders",
    operations: "Daily operations",
    support: "Exception handling",
  },
} as const;

export const getGuideSteps = (language: "zh" | "en"): GuideStep[] => {
  const t = GUIDE_STEP_TITLE_MAP[language];
  return [
    { id: 1, title: t.introduction, href: "/dropshipping/introduction" },
    { id: 2, title: t.account, href: "/dropshipping/account" },
    { id: 3, title: t.warehouseInfo, href: "/dropshipping/warehouse-info" },
    { id: 4, title: t.prepare, href: "/dropshipping/prepare" },
    { id: 5, title: t.shipping, href: "/dropshipping/shipping" },
    { id: 6, title: t.integration, href: "/dropshipping/integration" },
    { id: 7, title: t.operations, href: "/dropshipping/operations" },
    { id: 8, title: t.support, href: "/dropshipping/support" },
  ];
};
